// src/blogs/ThoughtsBlog.jsx
import React from "react";

import BlogShell from "./BlogShell.jsx";
import { thoughtsPosts } from "./blogData.js";
import { formatDate } from "./formatDate.js";
import PostBody from "./PostBody.jsx";
import PostPermalink from "./PostPermalink.jsx";
import { useScenePostClass } from "./ActivePostContext.js";
import { glassPanelRef } from "./glassPanels.js";
import "./ThoughtsBlog.css";

const MINI_HEAD_TARGET = { yaw: 0, pitch: 1 };

// Blog-wide 3D backdrop (see postScenes/ThoughtsCubesScene.jsx). Module-level
// so BlogShell's memoized theme merge sees a stable reference.
const DEFAULT_THEME = { scene: "thoughtsCubes" };

function ThoughtsPost({ post }) {
  const sceneClass = useScenePostClass(post);
  return (
    <article className={`thoughts-post ${sceneClass}`} ref={glassPanelRef}>
      <div className="thoughts-post__meta">
        <span>{formatDate(post.date)}</span>
        <span>{post.extra.readMinutes} min read</span>
        <PostPermalink id={post.id} />
      </div>
      <h2 className="thoughts-post__title gradient-text">{post.title}</h2>
      <PostBody post={post} textClassName="thoughts-post__excerpt" />
      <div className="thoughts-post__tags">
        {post.tags.map((tag) => (
          <span key={tag} className="thoughts-post__tag gradient-text">
            #{tag}
          </span>
        ))}
      </div>
    </article>
  );
}

export default function ThoughtsBlog({ onNavigateHome }) {
  return (
    <BlogShell
      themeClassName="thoughts-theme"
      posts={thoughtsPosts}
      renderPost={(post) => <ThoughtsPost key={post.id} post={post} />}
      miniHeadTarget={MINI_HEAD_TARGET}
      onNavigateHome={onNavigateHome}
      defaultTheme={DEFAULT_THEME}
      glassSidebar
      emptyLabel="thoughts"
    />
  );
}
